export enum AssembleiaTipoOrigem {
  DIGITAL = "DIGITAL",
  CANAL_VOZ = "CANAL_VOZ",
}